var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-lg-0 mx-auto"},[_c('router-link',{staticClass:"logo-img d-inline-block",staticStyle:{"width":"65px"},attrs:{"to":"/"}},[_c('img',{staticClass:"w-100 h-100",attrs:{"loading":"lazy","src":require("@/assets/images/new-logo.png"),"alt":"logo-top-shop"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }